"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulesPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var console_1 = require("../../../../reducers/slices/console");
var sql_connector_rules_1 = __importDefault(require("./components/sql_connector/sql_connector_rules"));
var RulesPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var pageTitle = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).pageTitle;
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Rules"));
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ className: "text-2xl font-[700] leading-[32px] mb-4" }, { children: pageTitle })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid gap-4" }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(sql_connector_rules_1.default, {}) }) }))] })));
};
exports.RulesPage = RulesPage;
exports.default = exports.RulesPage;
